// utils/heatmap.ts

/**
 * Retorna uma cor entre Verde e Vermelho baseado na porcentagem (0 a 1)
 * 120 é Verde (Low Load), 60 é Amarelo (Medium Load), 0 é Vermelho (High Load/Gargalo)
 * @param value Valor atual do card (TRA ou Carga)
 * @param maxValue Valor máximo encontrado no fluxo (Gargalo)
 * @returns string no formato hsl(...)
 */
export const getHeatmapColor = (value: number, maxValue: number): string => {
  if (maxValue <= 0 || value <= 0) return 'hsl(120, 80%, 95%)'; // Verde muito claro se zerado
  
  const ratio = Math.min(Math.max(value / maxValue, 0), 1);
  
  // HSL: 120 (Verde) -> 0 (Vermelho)
  // 120 * (1 - ratio)
  const hue = Math.round((1 - ratio) * 120);
  
  // Aumentamos a saturação e brilho para o heatmap ser visível mas legível
  return `hsl(${hue}, 80%, 60%)`; 
};

/**
 * Retorna uma versão suave da cor do heatmap para o fundo, 
 * permitindo que as bordas sejam mais escuras se desejado.
 */
export const getHeatmapSoftColor = (value: number, maxValue: number): string => {
  if (maxValue <= 0 || value <= 0) return 'hsl(120, 80%, 98%)';
  const ratio = Math.min(Math.max(value / maxValue, 0), 1);
  const hue = Math.round((1 - ratio) * 120);
  return `hsl(${hue}, 80%, 92%)`; // Lightness 92% para fundo suave
};
